import { meshComponent } from './Mesh'
import { props, createGeometry } from '../geometries/PlaneGeometry'

export default meshComponent('Plane', props, createGeometry)
